import { ClerkProvider } from "@clerk/react"
import { dark } from "@clerk/themes"
import * as React from "react"
import { useTheme } from "@/components/global/theme/theme-provider"

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
if (!PUBLISHABLE_KEY) {
	throw new Error("Add your Clerk Publishable Key to the .env.local file")
}

export default function AppClerkProvider({
	children,
}: {
	children: React.ReactNode
}) {
	const { theme } = useTheme()
	const [isDark, setIsDark] = React.useState(false)

	React.useEffect(() => {
		const darkMode =
			theme === "dark" ||
			(theme === "system" &&
				window.matchMedia("(prefers-color-scheme: dark)").matches)
		setIsDark(darkMode)
	}, [theme])

	return (
		<ClerkProvider
			publishableKey={PUBLISHABLE_KEY}
			afterSignOutUrl="/login"
			signInUrl="/login"
			appearance={{
				theme: isDark ? dark : undefined,
				elements: {
					formButtonPrimary:
						"bg-primary text-primary-foreground hover:bg-primary/90",
					card: "bg-card",
				},
			}}
		>
			{children}
		</ClerkProvider>
	)
}
